<template>
  <div class="add-edit-document">
    <div class="col">
      <div class="row">
        <div class="col">
          <form
            class="form-inline py-2 justify-content-between align-items-center"
            @submit.prevent
          >
            <div class="d-flex col-8">
              <button
                type="button"
                class="btn btn-back btn-lg"
                @click="onCancel"
              >
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <input
                type="text"
                placeholder="Название шаблона"
                v-model="name"
                class="form-control form-control-lg ml-3 w-50"
              >
              <div class="add-edit-document__toggle pt-2 ml-2 mt-1">
                <div
                  class="add-edit-document__property-pill mr-2"
                  v-if="enabled"
                >
                  <span>включен</span>
                </div>
                <span
                  class="cursor-pointer mr-2"
                  v-else
                  @click="enabled = true"
                >включен</span>
                <div
                  class="add-edit-document__property-pill add-edit-document__property-pill--disabled"
                  v-if="!enabled"
                >
                  <span>отключен</span>
                </div>
                <span
                  class="cursor-pointer"
                  v-else
                  @click="enabled = false"
                >отключен</span>
              </div>
            </div>
            <div class="col-4">
              <button
                v-if="id"
                type="button"
                class="btn btn-secondary"
                @click="onDelete"
              ><i class="ico ico-delete px-2" />Удалить</button>
              <button
                type="button"
                class="btn btn-secondary ml-2"
                @click="onCancel"
              >Отменить</button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                @click="onSave"
              >Сохранить</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <form
            class="form-inline py-2 align-items-center"
            @submit.prevent
          >
            <label for="description">Описание:</label>
            <textarea
              type="text"
              rows="1"
              class="form-control ml-3 mr-5"
              id="description"
              v-model="description"
            ></textarea>
            <label for="orientation ml-5">Ориентация:</label>
            <div
              class="add-edit-document__toggle ml-2 mr-5"
              id="orientation"
            >
              <div
                class="add-edit-document__property-pill mr-2"
                v-if="!orientation"
              >
                <span>книжная</span>
              </div>
              <span
                class="cursor-pointer mr-2"
                v-else
                @click="orientation = false"
              >книжная</span>
              <div
                class="add-edit-document__property-pill"
                v-if="orientation"
              >
                <span>альбомная</span>
              </div>
              <span
                class="cursor-pointer"
                v-else
                @click="orientation = true"
              >альбомная</span>
            </div>
            <button
                v-if="id"
                type="button"
                class="btn btn-sm btn-secondary"
                @click="setLayoutMargins"
              >Установить отступы</button>
          </form>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col add-edit-document__editor">
          <div
            class="add-edit-document__ckeditor"
            :style="{width: !orientation ? '210mm' : '297mm'}"
          >
           <ckeditor v-if="showEditor" v-model="body" :config="editorConfig"></ckeditor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
import ckeditor from '../../../components/ckeditor'
import DocumentMarginsModal from './DocumentMarginsModal'

const getEditorConfig = (placeholderGroups) => {
  return {
    autoGrow_minHeight: 600,
    autoGrow_onStartup: true,
    extraPlugins: 'placeholder,justify,font,colorbutton,liststyle,preview,placeholder_select,autogrow,table,tableresize',
    language: 'ru',
    allowedContent: true,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
      { name: 'insert', groups: ['placeholder'] },
      { name: 'forms', groups: ['forms'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      '/',
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },
      '/',
      { name: 'others', groups: ['placeholder'] }
    ],
    placeholder_select: { placeholderGroups }
  }
}

export default {
  name: 'AddEditDocument',
  components: {
    ckeditor
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      placeholders: [],
      editorConfig: null,
      name: '',
      enabled: true,
      orientation: false,
      body: '',
      description: '',
      showEditor: false,
      margin: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Создание шаблона документа')
    })
  },
  async created () {
    await Promise.all([this.setSnippets(), this.setDocumentData()])
    this.editorConfig = getEditorConfig(this.placeholderGroups)
    this.showEditor = true
  },
  computed: {
    allPlaceholders () {
      let result = []

      Object.keys(this.placeholders).forEach(x => {
        result = result.concat(this.placeholders[x].map(y => {
          return { id: y.id, label: y.name }
        }))
      })

      return result
    },
    placeholderGroups () {
      const groups = Object.keys(this.placeholders).reverse()
      return groups.map(x => ({ name: this.getGroupName(x), placeholders: this.placeholders[x].map(y => ({ id: y.name, name: this.$t(y.name.replace(/\|/g, '_')) })) }))
    }
  },
  methods: {
    async setSnippets () {
      const response = await api.get.documentPlaceholders()
      this.placeholders = response.data.data.placeholders
    },
    async setDocumentData () {
      if (this.id) {
        const response = await api.get.documentLayout(this.id)
        const doc = response.data.data.layout
        this.name = doc.name
        this.enabled = doc.enabled
        this.orientation = doc.orientation
        this.body = doc.body
        this.description = doc.description
        this.margin = doc.margin
      }
    },
    onCancel () {
      this.$router.push('/settings/documents')
    },
    onDelete () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.delete
                .documentLayout(this.id)
                .then(() => {
                  this.$modal.hide('dialog')
                })
              this.$modal.hide('dialog')
              this.onCancel()
            }
          }
        ]
      })
    },
    async onSave () {
      const model = {
        name: this.name,
        enabled: this.enabled,
        orientation: this.orientation,
        body: this.body,
        description: this.description,
        margin: this.margin
      }

      if (this.id) {
        await api.post.editDocumentLayout(this.id, model)
      } else {
        await api.post.addDocumentLayout(model)
      }

      this.onCancel()
    },
    getGroupName (name) {
      switch (name) {
        case 'TechnicalMap':
          return 'Техкарта'
        case 'FinanceInvoice':
          return 'Финансы'
        case 'Document':
          return 'Документ'
        case 'Task':
          return 'Задача'
        case 'Customer':
          return 'Компания'
        case 'Client':
          return 'Клиент'
        case 'Other':
          return 'Личные'

        default:
          return name
      }
    },
    setLayoutMargins () {
      this.$eventBus.$on('set-document-margins', (margin) => {
        this.margin = margin
        this.$eventBus.$off('set-document-margins')
      })
      this.$modal.show(DocumentMarginsModal, { documentMargins: this.margin || undefined }, {
        height: 'auto'
      })
    }
  }
}
</script>

<style lang="scss">
.add-edit-document {
  &__property-pill {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: 84px;
    height: 17px;
    color: #fff;
    background-color: #28bd8b;
    border-radius: 4px;

    &--disabled {
      background-color: #f34d65;
    }
  }

  &__ckeditor{
    position: relative;
    background-color: #fff;
  }

  .cke_button__createplaceholder{
    display: none;
  }

  .cke_top{
    position: sticky;
    top: 50px;
  }
}
</style>
